export const SALES_LIKE_ROLES = ['sales', 'support'] as const
export const ASSIGNABLE_REVIEW_ROLES = ['admin', 'dev'] as const

export const isSalesLikeRole = (role: string | null | undefined) =>
  SALES_LIKE_ROLES.includes((role || '') as (typeof SALES_LIKE_ROLES)[number])

export const isAssignableReviewRole = (role: string | null | undefined) =>
  ASSIGNABLE_REVIEW_ROLES.includes((role || '') as (typeof ASSIGNABLE_REVIEW_ROLES)[number])
